import React, { useEffect, useRef } from 'react';
import './ParticleEffect.css';

function Pickles() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Set the canvas size to be the same as the window size
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Define the particles
    const particles = [];
    const numParticles = 1000;
    for (let i = 0; i < numParticles; i++) {
      const size = Math.floor(Math.random() * 3) + 1; // random size between 1 and 3
      const x = Math.random() * canvas.width;
      const y = Math.random() * canvas.height;
      const color = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, ${Math.floor(Math.random() * 255)}, 0.5)`;
      const speed = Math.random() * 3 + 1;
      const direction = Math.random() * 360;
      particles.push({
        x,
        y,
        w: size * 2, // double the size for wider particles
        h: size * 5,
        color,
        speed,
        direction,
      });
    }

    // Define the animation loop
    function animate() {
      // Clear the canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw the particles
      particles.forEach((p) => {
        // Move the particle
        const radians = (p.direction * Math.PI) / 180;
        p.x += Math.cos(radians) * p.speed;
        p.y += Math.sin(radians) * p.speed;

        // Wrap around the edges of the screen
        if (p.x < -p.w) {
          p.x = canvas.width + p.w;
        }
        if (p.x > canvas.width + p.w) {
          p.x = -p.w;
        }
        if (p.y < -p.h) {
          p.y = canvas.height + p.h;
        }
        if (p.y > canvas.height + p.h) {
          p.y = -p.h;
        }

        // Draw the particle
        ctx.fillStyle = p.color;
        ctx.fillRect(p.x - p.w / 2, p.y - p.h / 2, p.w, p.h);
      });

      // Add centered text
      //   const text = 'Welcome to my website!';
      //   ctx.font = '48px sans-serif';
      //   ctx.fillStyle = 'white';
      //   ctx.textAlign = 'center';
      //   ctx.fillText(text, canvas.width / 2, canvas.height / 2);

      // Request the next animation frame
      requestAnimationFrame(animate);
    }

    // Start the animation loop
    animate();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="ParticleEffect"
      style={{ position: 'fixed', top: 0, left: 0 }}
    />
  );
}

export default Pickles;
